import './styles.scss'

const CLASS_NAME = 'app-background'

export const AppBackground = () => {
  return (
    <div className={CLASS_NAME}>
      <div className={`${CLASS_NAME}__foreground`} />
    </div>
  )
}
